import { HourTypeEnum } from './type'

export const STAFF_PLANNING_WEEKS_NUMBER = 18
export const COLLABORATOR_COUNT_EXPIRATION_DAYS_THRESHOLD = 28

export const RELEVANT_HOUR_TYPES = [
  HourTypeEnum.COMMERCIAL,
  HourTypeEnum.CASH,
  HourTypeEnum.BUSINESS_PREPARATION,
  HourTypeEnum.RSB
]

export const AFFINITY_RATE_SUPPORTED_HOUR_TYPES = [HourTypeEnum.COMMERCIAL, HourTypeEnum.CASH, HourTypeEnum.ALL]
